var sentenceCase = require('sentence-case')

/**
 * Param case a string.
 *
 * @param  {String} string
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (string, locale) {
  return sentenceCase(string, locale, '-')
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/change-case/~/param-case/param-case.js
 ** module id = 271
 ** module chunks = 1
 **/